import React from 'react';
import { useTranslate } from 'react-admin';
import { Typography, Card, CardContent } from '@material-ui/core';

import IFormValues from '../types';
import { getBody } from './emailTemplateMapper';

import './styles.scss';

const Sidebar = ({ formValues, isAdmin }: { formValues: IFormValues; isAdmin?: boolean }) => {
  const translate = useTranslate();
  const { testType, language, partnerCode } = formValues;

  const EmailExample =
    partnerCode && testType && language
      ? getBody(partnerCode, testType, language, isAdmin)
      : null;

  return (
    <Card className="sidebar">
      <CardContent>
        {testType && language ? (
          <div className="sidebar__body">{EmailExample}</div>
        ) : (
          <Typography variant="body2">
            {translate('tests.emailPreviewText')}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default Sidebar;
